import {LIFF_IDS} from "./constants";

const env = process.env.REACT_APP_ENV;

export const getLiffId = (pageName: string) => {
  if (!(pageName in LIFF_IDS))
    return null;

  if (env === 'production') {
    return LIFF_IDS[pageName].production;
  } else if (env === 'development') {
    return LIFF_IDS[pageName].development;
  }
}